import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'

export default {
  aboutBatteryHealth: {
    id: 'product_jp_about_battery_health',
    defaultMessage: 'About battery health',
  },
  content1: {
    id: 'product_jp_about_battery_modal_content_1',
    defaultMessage:
      'Electronic devices like smartphones and laptops can experience battery wear over time, especially with frequent charging or use while charging, which leads to a decrease in battery capacity.',
  },
  content2: {
    id: 'product_jp_about_battery_modal_content_2',
    defaultMessage:
      'At Back Market, we ensure that all devices sold have a battery capacity of 80-100%. If you prefer a device with a guaranteed 100% battery capacity, you can choose the option with a brand-new battery.',
  },
} as Record<string, I18nDefinition>
